import { PageConfigTypes } from "app/types/PageTypes";
import { ROLES } from "app/constants/roles";
import CouponsPage from "./CouponsPage";
import PromotionalCouponsPage from "./PromotionalCouponsPage";
import CouponReservationsPage from "./CouponReservationsPage";
const CouponsPageConfig: PageConfigTypes = {
  baseRoute: {
    path: "/coupons",
    exact: true,
    component: CouponsPage,
    authorities: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER],
  },
  subRoutes: [
    { path: "/coupons/promotional", component: PromotionalCouponsPage, authorities: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER] },
    { path: "/coupons/reservations", component: CouponReservationsPage, authorities: [ROLES.ROLE_ADMIN, ROLES.ROLE_CUSTOMER] },
  ],
  settings: {},
};

export default CouponsPageConfig;
